"use client";

export default function Home() {
  return (
    <div className="space-y-16">
      <section className="text-center">
        <h1 className="text-6xl font-mono uppercase tracking-widest mb-6 bg-gradient-to-r from-rose-500 via-purple-500 to-cyan-500 bg-clip-text text-transparent">
          NEON KITCHEN
        </h1>
        <p className="text-lg text-gray-400 max-w-3xl mx-auto font-mono">
          [ CYBER CUISINE :: DIGITAL DINING :: FUTURE FOOD ]
        </p>
      </section>

      <section className="grid md:grid-cols-2 gap-8">
        <div className="border border-rose-900 p-8 rounded bg-black/50">
          <h3 className="text-2xl font-mono text-rose-500 mb-4 flex items-center">
            <span className="text-cyan-500 mr-2">▶</span> SIGNATURE DISHES
          </h3>
          <p className="text-gray-400 font-mono text-sm">
            Molecular gastronomy meets street food culture in our innovative
            fusion menu.
          </p>
        </div>
        <div className="border border-purple-900 p-8 rounded bg-black/50">
          <h3 className="text-2xl font-mono text-purple-500 mb-4 flex items-center">
            <span className="text-cyan-500 mr-2">▶</span> DIGITAL ORDERING
          </h3>
          <p className="text-gray-400 font-mono text-sm">
            Seamless tech-integrated experience from order to delivery.
          </p>
        </div>
      </section>

      <section className="text-center">
        <button className="px-12 py-4 bg-gradient-to-r from-rose-600 to-purple-600 text-white font-mono uppercase tracking-wider hover:shadow-lg hover:shadow-rose-500/50 transition">
          [ ENTER MENU ]
        </button>
      </section>
    </div>
  );
}
